export default {
  TITLE: 'AMAL in Heritage',
}



// WEBPACK FOOTER //
// ./src/constants/meta.js